import { complement } from 'ramda';

import isArray from './isArray';

/**
 * Checks if input value is complement of `Array`
 *
 * @func isNotArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.3.0|v0.3.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {Boolean}
 * @see {@link RA.isArray|isArray}
 * @example
 *
 * RA.isNotArray([]); //=> false
 * RA.isNotArray(null); //=> true
 * RA.isNotArray({}); //=> true
 */
var isNotArray = /*#__PURE__*/complement(isArray);

export default isNotArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isNotArray.js
// module id = 730
// module chunks = 0